export const EXACT_CELL_EDITOR_STYLE = {
    width: 0,
    height: 0,
    maxWidth: "none",
    maxHeight: "none",
    borderRadius: 0,
    boxShadow: "0 0 0 1px var(--gdg-accent-color)",
};
export function withExactCellEditor(provide) {
    return (cell) => {
        const result = provide(cell);
        if (result && typeof result === "object" && "editor" in result) {
            return { styleOverride: EXACT_CELL_EDITOR_STYLE, ...result };
        }
        return result;
    };
}
//# sourceMappingURL=exactCellEditor.js.map